<template>
    <v-dialog v-model="dialog" max-width="700" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="pt-5 pb-13 px-5">
            <v-row justify="end" class="ma-0">
                <v-btn icon>
                    <v-icon @click="dialog = false">mdi-close</v-icon>
                </v-btn>
            </v-row>

            <v-row justify="center" align="center" class="mx-0 mb-7 mt-5">
                <svg v-svg="'icon-settings'" size="28" class="mr-2"></svg>
                <h2 class="text-center">Settings</h2>
            </v-row>

            <div class="pa-4 tree-view">
                <v-progress-linear :indeterminate="true" v-if="loadingRequest"></v-progress-linear>

                <v-treeview :items="courses" hoverable v-else class="font-weight-bold black--text">
                    <template v-slot:prepend="{ item }">
                        <svg v-svg="'icon-settings-lesson'" size="15" v-if="item.type === 'lesson'"></svg>
                        <i :class="item.icon" v-else></i>
                    </template>

                    <template v-slot:append="{ item }">
                        <v-switch class="mb-0 mt-0"
                                  :input-value="Object.values(settings[item.type + 's']).find((data) => data[item.type + '_id'] === item.id) ? 1 : 0"
                                  @change="enableDisable(item.type, item.id, $event)"
                                  color="success"
                        >
                        </v-switch>
                    </template>
                </v-treeview>

                <v-list subheader class="black--text font-weight-bold mt-10">
                    <v-subheader>Quizzes</v-subheader>
                    <v-list-item v-for="(course, index) in courses" :key="index">
                        <v-list-item-content>
                            <v-list-item-title class="black--text">{{ course.name }}</v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-switch class="mb-0 mt-0"
                                      :input-value="quizzes.find(item => item.course_id === course.id) ? 1 : 0"
                                      @change="toggleQuiz(course.id, $event)"
                                      color="success"
                            >
                            </v-switch>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['team_id'],
        data(){
            return {
                dialog: false,
                loadingRequest: false,
                loadingSave: false,
                settings: null,
                courses: [],
                quizzes: [],
            }
        },

        watch: {
            'team_id': function (newVal) {
                if(newVal) {
                    this.getSettings();
                    this.getSubjects();
                }
            }
        },

        methods: {
            enableDisable(type, id, value){
                this.loadingSave = true;
                this.$apiAdmin('teams').permissions({type, id, value, ...{team_id: this.team_id}}).then(() => {
                    this.$store.dispatch('alert', {type: 1, message: 'Successfully updated.'});
                }).finally(() => {
                    this.loadingSave = false;
                })
            },

            toggleQuiz(id, value){
                this.$apiAdmin('teams').quizzes({value, course_id : id, ...{ team_id: this.team_id }}).then(() => {
                    this.$store.dispatch('alert', {type: 1, message: 'Successfully updated.'});
                });
            },

            getSettings(){
                this.loadingRequest = true;
                this.$apiAdmin('teams').settings(this.team_id).then((res) => {
                    this.settings = res.data.settings;
                    this.quizzes  = res.data.quizzes;
                    this.loadingRequest = false;
                })
            },

            getSubjects(){
                this.$apiAdmin('subjects').getFullSubject({params: {all: 1}}).then((res) => {
                    this.courses = res.data.courses;
                    this.courses.map((function (course) {
                        course.type = 'course';
                        course.children = course.lessons.map(function (lesson) {
                            lesson.name = lesson.title;
                            lesson.type = 'lesson';
                            return lesson;
                        });
                        return course;
                    }))
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/settings";
</style>